import { render, staticRenderFns } from "./RateItem.vue?vue&type=template&id=76eab52e&scoped=true"
import script from "./RateItem.vue?vue&type=script&lang=js"
export * from "./RateItem.vue?vue&type=script&lang=js"
import style0 from "./RateItem.vue?vue&type=style&index=0&id=76eab52e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eab52e",
  null
  
)

export default component.exports